module.exports = __webpack_public_path__ + "static/media/card_voxy_hh.9f653e2b.png";